import { Component, OnInit, ViewChild, Inject, AfterContentInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MapsAPILoader } from '@agm/core';
import { MovilMarker } from 'src/app/models/movilmarker.model';
import { Constant } from '../../constant';

declare var google: any;

export interface DialogData {
  latitud: number;
  longitud: number;
  rotacion: number;
}

@Component({
  selector: 'app-mapa-popup', 
  templateUrl: './mapa-popup.component.html',
  styleUrls: ['./mapa-popup.component.scss']
})
export class MapaPopUpComponent implements OnInit, AfterContentInit {
  
  @ViewChild('mapa') gmapElement: any;
  map;
  markers: MovilMarker[] = [];  

  constructor(
    private mapsApiLoader: MapsAPILoader,
    private constant: Constant,
    public dialogRef: MatDialogRef<MapaPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { 
    // this.markers.push(
    //   { 
    //     'nombre': 'Marker 1', 
    //     'lat': -25.271707, 
    //     'lng': -57.593533,
    //     'rotacion': 0
    //   },  
    // );
  }

  ngAfterContentInit(): void {
    this.mapsApiLoader.load().then(() => {
      this.initMap();
    });
  }

  ngOnInit() {
    this.markers.push( new MovilMarker('nombre', this.data.latitud, this.data.longitud, this.data.rotacion ) );
  }

  initMap() {
    let configMap = this.constant.mapConfig();
    configMap.zoom = 15;
    configMap.center = new google.maps.LatLng( this.data.latitud, this.data.longitud );
    this.map = new google.maps.Map(
      this.gmapElement.nativeElement,
      configMap
    );
    this.getPoints();
  }

  getPoints() {
    //var infowindow = new google.maps.InfoWindow();
    return this.markers.map((point,i) => {
      this.addMarker(point.nombre, point.lat, point.lng, point.rotacion );     
    });
  }

  /**
   * Agrega Marcadores
   * @param titulo Titulo del marcador
   * @param lat Latitud
   * @param lng Longitud
   */
  addMarker( titulo:string, lat:number, lng:number, rotacion ){
    let infowindow = new google.maps.InfoWindow({
      content: `<h1>${titulo}</h1>
      <button mat-button>Cargar Punto</button>`
    });
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      map: this.map,
      rotation: rotacion,
      icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
				rotation: rotacion,
				scale: 4,
				fillColor: '#16a085',
				fillOpacity: 0.8,
				strokeColor: '#2ecc71',
				strokeOpacity: 0.9,
				strokeWeight: 2
      }      
    });
    marker.addListener('click', function() {
      infowindow.open(this.map, marker);
    });
    this.markers.push(marker);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
